import { apiClient } from '@/shared/api/client';
import type { ApiResponse } from '@/shared/types/api.types';
import type { InspectionStatus, InspectionVerification } from '../types/inspection.types';

const BASE_ENDPOINT = '/super-admin/verifications';

export const inspectionService = {
  async listVerificationsForInspection(
    status: InspectionStatus = 'ACCEPTED'
  ): Promise<InspectionVerification[]> {
    const response = await apiClient<ApiResponse<InspectionVerification[]>>(
      `${BASE_ENDPOINT}?status=${status}`,
      { method: 'GET' }
    );
    return response.data;
  },

  async approveVerification(verificationId: string): Promise<InspectionVerification> {
    const response = await apiClient<ApiResponse<InspectionVerification>>(
      `${BASE_ENDPOINT}/${verificationId}/approve`,
      { method: 'POST' }
    );
    return response.data;
  },

  async returnVerification(
    verificationId: string,
    comment: string
  ): Promise<InspectionVerification> {
    const response = await apiClient<ApiResponse<InspectionVerification>>(
      `${BASE_ENDPOINT}/${verificationId}/reject`,
      { method: 'POST', body: { comment } }
    );
    return response.data;
  },
};
